import { render } from "./index-swiper.vue?vue&type=template&id=ae4b039e&scoped=true"
import script from "./index-swiper.vue?vue&type=script&lang=js"
export * from "./index-swiper.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae4b039e"]])

export default __exports__